<script setup lang="ts">
import { storyblokImage } from '~/utils/storyblok-image';
const props = defineProps({
    blok: {
        type: Object,
        default: () => ({}),
    },
});

const { toLocaleUrl } = useLocaleUrl();
const href = computed(() => toLocaleUrl(props.blok.link?.cached_url));
</script>

<template>
    <li>
        <a
            :href="href"
            :target="blok.link.target"
            class="hover:text-white text-purple-berry dark:hover:text-white dark:text-gray-400"
        >
            <img
                :src="storyblokImage(blok.logo.filename, { width: 40 })"
                :alt="blok.logo.alt"
                class="w-5 h-5"
                aria-hidden="true"
            />
        </a>
    </li>
</template>
